// store/versionSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VersionState {
  currentVersion: string;
  allVersions: string[];
}

const initialState: VersionState = {
  currentVersion: "version-1",
  allVersions: ["version-1"],
};

const versionSlice = createSlice({
  name: "version",
  initialState,
  reducers: {
    setCurrentVersion: (state, action: PayloadAction<string>) => {
      state.currentVersion = action.payload;
    },
    setAllVersions: (state, action: PayloadAction<string[]>) => {
      state.allVersions = action.payload;
    },
    addVersion: (state, action: PayloadAction<string>) => {
      state.allVersions.push(action.payload);
    },
    deleteVersion: (state, action: PayloadAction<string>) => {
      state.allVersions = state.allVersions.filter(v => v !== action.payload);
      if (state.currentVersion === action.payload) {
        state.currentVersion = state.allVersions[0] || "No Versions";
      }
    },
  },
});

export const { setCurrentVersion, setAllVersions, addVersion, deleteVersion } = versionSlice.actions;
export default versionSlice.reducer;
